import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  Icon,
  Tooltip,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import _ from "lodash";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsToProps as ActionMap } from "../../redux/cloudPBX/action";
import { mapActionsToProps as DialplanAction } from "../../redux/cloudPBX/dialplan";
import { mapActionsToProps as ExtensionAction } from "../../redux/cloudPBX/extension";
import { mapActionsToProps } from "../../redux/cloudPBX/ivr";
import { mapActionsToProps as PhonenumberAction } from "../../redux/cloudPBX/phoneNumber";
import { mapActionsToProps as QueueAction } from "../../redux/cloudPBX/queue";
import { mapActionsToProps as SoundAction } from "../../redux/cloudPBX/sound";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
});

class Dialplan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      showpassword: false,
      modalAction: false,
      menuItems: [],
      parameters: [],
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.props.getListAction("createdAt DESC", 999);
    this.props.getListSound("createdAt DESC", 999);
    this.props.getListIvr("createdAt DESC", 999);
    this.props.getListPhoneNumber("createdAt DESC", 999);
    this.props.getListExtension("createdAt DESC", 999);
    this.props.getListQueue("createdAt DESC", 999);
    // this.addItem()
  }

  listCollumns = [
    { id: "title", numeric: true, disablePadding: false, label: "Tiêu đề" },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian tạo",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "title":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListDialplan(filters.order, filters.pageSize, filters.page, {
      where,
    });
    this.props.countListDialplan({ where });
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalAction: false, modalDelete: false });
  };

  openModalEdit = (item) => {
    const { listAction } = this.props;
    this.state.item = item;
    let _menuItems = [];
    item.actions.map((menu, key) => {
      const suffix =
        Math.random().toString(36).substring(2, 24) +
        Math.random().toString(36).substring(2, 24);
      const _action = listAction.find((a) => a.id == menu.action);
      if (_action) {
        _menuItems.push({
          idMenu: suffix,
          ...menu,
          parameters: [..._action.parameters],
        });
      }
    });
    this.setState({
      menuItems: _menuItems,
    });
    this.setState({ modalAction: true });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = { like: value };
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        itemCreate: {
          ...this.state.itemCreate,
          [name]: e.target.value,
        },
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({
      modalAction: true,
      item: {},
      menuItems: [],
      itemCreate: {},
    });
  };

  handleAction = () => {
    const { id } = this.state.item;
    let actions = _.map(this.state.menuItems, function (m) {
      return _.omit(m, ["idMenu", "parameters"]);
    });
    if (!id) {
      const { title } = this.state.itemCreate;
      return (
        this.props.addDialplan(title, actions),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    } else {
      const { id, title } = this.state.item;
      return (
        this.props.editDialplan(
          id,
          title,
          actions,
          this.props.listSound &&
            this.props.listSound.length &&
            this.props.listSound[0].definedName
            ? this.props.listSound[0].definedName
            : null
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deleteDialplan(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleDateChangeFrom = (date) => {
    this.setState({
      startAt: datetimeHelper.toFormat(date, "YYYY-MM-DD HH:mm:ss"),
    });
  };

  handleDateChangeTo = (date) => {
    this.setState({
      endAt: datetimeHelper.toFormat(date, "YYYY-MM-DD HH:mm:ss"),
    });
  };

  addItem = () => {
    let { menuItems } = this.state;
    const suffix =
      Math.random().toString(36).substring(2, 24) +
      Math.random().toString(36).substring(2, 24);
    if (menuItems.length <= 11) {
      return this.setState({
        menuItems: menuItems.concat([
          { idMenu: suffix, code: "", action: "", parameters: [] },
        ]),
      });
    }
  };

  removeMenu = (id) => {
    this.setState({
      menuItems: this.state.menuItems.filter((item) => item.idMenu !== id),
    });
  };

  handleChangeEditMenu = (value, name, id) => {
    const { menuItems } = this.state;
    const { listAction } = this.props;
    let _parameters = [];
    let menu = menuItems.find((item) => item.idMenu == id);
    if (menu) {
      menu[name] = value;
      this.setState(
        {
          menuItems,
        },
        () => {
          if (name === "action") {
            const _action = listAction.find((item) => item.id == value);
            if (_action) {
              _parameters.push(..._action.parameters);
              menu["parameters"] = [..._parameters];
              this.setState({
                menuItems,
              });
            }
          }
        }
      );
    }
  };

  handleChangeParamesters = (value, name, idMenu) => {
    const { menuItems } = this.state;
    let menu = menuItems.find((i) => i.idMenu === idMenu);
    if (menu) {
      menu[name] = value;
      this.setState({ menuItems });
    }
  };

  render() {
    const {
      classes,
      listIvr,
      coutDialplan,
      listAction,
      listPhoneNumber,
      listQueue,
      listSound,
      listDialplan,
      listExtension,
    } = this.props;
    const {
      id,
      title,
      startSoundFile,
      invalidSoundFile,
      menuItems,
      filters,
      item,
      modalDelete,
      itemCreate,
    } = this.state;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;
    const listExtensionResult =
      typeof listExtension === "object"
        ? Object.keys(listExtension).map((key) => listExtension[key])
        : listExtension;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Tiêu đề"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={
                            filters.where.title ? filters.where.title.like : ""
                          }
                          name="title"
                        />
                      </Grid>
                      <Grid item md={3}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách dialplan"
          items={listDialplan}
          rowsPerPage={filters.pageSize}
          count={this.props.count ? this.props.count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                size="small"
                onClick={this.handleCreateModel}>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={this.state.modalAction}
          title={
            item ? (item.id ? "Chỉnh sửa dialplan" : "Thêm mới dialplan") : null
          }
          maxWidth={"md"}
          fullWidth={true}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <Grid item md={12} style={{ padding: 5 }}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Tiêu đề"
                      variant="outlined"
                      autoFocus={true}
                      className={classes.input}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("title")
                            : this.handleChangeText("title")
                          : null
                      }
                      value={
                        item ? (item.id ? item.title : itemCreate.title) : null
                      }
                    />
                  </Grid>
                  <div style={{ alignItems: "center", display: "flex" }}>
                    <FormLabel style={{ marginRight: 10 }}>
                      Thêm hành động
                    </FormLabel>
                    <Tooltip title="Thêm hành động">
                      <Button
                        variant="fab"
                        mini
                        color="primary"
                        aria-label="Add"
                        className={classes.button}
                        onClick={() => this.addItem()}>
                        <Icon>add</Icon>
                      </Button>
                    </Tooltip>
                  </div>
                </Grid>
                {this.state.menuItems.map((menu, key) => {
                  return (
                    <Card style={{ marginBottom: 10 }}>
                      <Grid container alignItems="center">
                        <Grid md={11} item>
                          <Grid
                            container
                            style={{ alignItems: "center", marginBottom: 10 }}>
                            <Grid item md={6} style={{ padding: 5 }}>
                              <TextValidator
                                id="outlined-full-width"
                                margin="normal"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Thứ tự"
                                variant="outlined"
                                className={classes.input}
                                onChange={(e) =>
                                  this.handleChangeEditMenu(
                                    e.target.value,
                                    e.target.name,
                                    menu.idMenu
                                  )
                                }
                                value={menu.code}
                                name="code"
                              />
                            </Grid>
                            <Grid item md={6} style={{ padding: 5 }}>
                              <SelectValidator
                                id="outlined-full-width"
                                margin="normal"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                select
                                label="Action"
                                variant="outlined"
                                className={classes.input}
                                onChange={(e) =>
                                  this.handleChangeEditMenu(
                                    e.target.value,
                                    e.target.name,
                                    menu.idMenu
                                  )
                                }
                                value={menu.action}
                                name="action">
                                {listAction ? (
                                  listAction.map((item, key) => {
                                    return (
                                      <MenuItem value={item.id} key={key}>
                                        {item.title}
                                      </MenuItem>
                                    );
                                  })
                                ) : (
                                  <React.Fragment />
                                )}
                              </SelectValidator>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid md={1} item>
                          <IconButton
                            onClick={() => this.removeMenu(menu.idMenu)}>
                            <Icon>delete</Icon>
                          </IconButton>
                        </Grid>
                      </Grid>
                      <Grid container alignItems="center">
                        {menu.parameters != undefined
                          ? menu.parameters.map((para, key) => {
                              switch (para.type) {
                                case "select": {
                                  return (
                                    <Grid
                                      item
                                      md={3}
                                      style={{ padding: 5, maxWidth: "100%" }}>
                                      <SelectValidator
                                        id="outlined-full-width"
                                        margin="normal"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        select
                                        required
                                        label={para.title}
                                        fullWidth
                                        variant="outlined"
                                        className={classes.input}
                                        onChange={(e) =>
                                          this.handleChangeParamesters(
                                            e.target.value,
                                            e.target.name,
                                            menu.idMenu
                                          )
                                        }
                                        value={menu[para.value]}
                                        name={para.value}
                                        validators={["required"]}
                                        errorMessages={[`Không được để trống`]}>
                                        {para.resource === "extension" ? (
                                          listExtensionResult ? (
                                            listExtensionResult.map(
                                              (i, key) => {
                                                return (
                                                  <MenuItem
                                                    key={key}
                                                    value={i.username}>
                                                    {i.name} - {i.username}
                                                  </MenuItem>
                                                );
                                              }
                                            )
                                          ) : (
                                            <React.Fragment />
                                          )
                                        ) : para.resource === "number" ? (
                                          listPhoneNumberResult ? (
                                            listPhoneNumberResult.map(
                                              (i, key) => {
                                                return (
                                                  <MenuItem
                                                    key={key}
                                                    value={i.id}>
                                                    {i.id}
                                                  </MenuItem>
                                                );
                                              }
                                            )
                                          ) : (
                                            <React.Fragment />
                                          )
                                        ) : para.resource === "soundFile" ? (
                                          listSound ? (
                                            listSound.map((i, key) => {
                                              return (
                                                <MenuItem
                                                  key={key}
                                                  value={i.id}>
                                                  {i.name}
                                                </MenuItem>
                                              );
                                            })
                                          ) : (
                                            <React.Fragment />
                                          )
                                        ) : para.resource === "ivr" ? (
                                          listIvr ? (
                                            listIvr.map((i, key) => {
                                              return (
                                                <MenuItem
                                                  key={key}
                                                  value={i.id}>
                                                  {i.title}{" "}
                                                </MenuItem>
                                              );
                                            })
                                          ) : (
                                            <React.Fragment />
                                          )
                                        ) : para.resource === "queue" ? (
                                          listQueue ? (
                                            listQueue.map((i, key) => {
                                              return (
                                                <MenuItem
                                                  key={key}
                                                  value={i.id}>
                                                  {i.name}
                                                </MenuItem>
                                              );
                                            })
                                          ) : (
                                            <React.Fragment />
                                          )
                                        ) : para.resource === "dialplan" ? (
                                          listDialplan ? (
                                            listDialplan.map((i, key) => {
                                              return (
                                                <MenuItem
                                                  key={key}
                                                  value={i.id}>
                                                  {i.title}
                                                </MenuItem>
                                              );
                                            })
                                          ) : (
                                            <React.Fragment />
                                          )
                                        ) : (
                                          <React.Fragment>
                                            <MenuItem value="eq">Bằng</MenuItem>
                                            <MenuItem value="neq">
                                              Khác
                                            </MenuItem>
                                            <MenuItem value="gt">
                                              Lớn hơn
                                            </MenuItem>
                                            <MenuItem value="qte">
                                              Lớn hơn bằng
                                            </MenuItem>
                                            <MenuItem value="lt">
                                              Nhỏ hơn
                                            </MenuItem>
                                            <MenuItem value="lte">
                                              Nhỏ hơn bằng
                                            </MenuItem>
                                            <MenuItem value="like">
                                              Giống
                                            </MenuItem>
                                          </React.Fragment>
                                        )}
                                      </SelectValidator>
                                    </Grid>
                                  );
                                }
                                case "number": {
                                  return (
                                    <Grid
                                      item
                                      md={3}
                                      style={{ padding: 5, maxWidth: "100%" }}>
                                      <TextValidator
                                        id="outlined-full-width"
                                        margin="normal"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        type="number"
                                        label={para.title}
                                        variant="outlined"
                                        className={classes.input}
                                        onChange={(e) =>
                                          this.handleChangeParamesters(
                                            e.target.value,
                                            e.target.name,
                                            menu.idMenu
                                          )
                                        }
                                        value={menu[para.value]}
                                        name={para.value}
                                        required
                                        validators={["required"]}
                                        errorMessages={[`Không được để trống`]}
                                      />
                                    </Grid>
                                  );
                                }
                                case "text": {
                                  return (
                                    <Grid
                                      item
                                      md={3}
                                      style={{ padding: 5, maxWidth: "100%" }}>
                                      <TextValidator
                                        id="outlined-full-width"
                                        margin="normal"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        label={para.title}
                                        variant="outlined"
                                        className={classes.input}
                                        onChange={(e) =>
                                          this.handleChangeParamesters(
                                            e.target.value,
                                            e.target.name,
                                            menu.idMenu
                                          )
                                        }
                                        value={menu[para.value]}
                                        name={para.value}
                                        required
                                        validators={[
                                          "required",
                                          "matchRegexp:^[a-z-0-9]{4,}$",
                                        ]}
                                        errorMessages={[
                                          `Không được để trống`,
                                          "Nhiều hơn 4 ký tự",
                                        ]}
                                      />
                                    </Grid>
                                  );
                                }
                                default:
                                  break;
                              }
                            })
                          : null}
                      </Grid>
                    </Card>
                  );
                })}
              </FormControl>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}>
                  Lưu
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
      </React.Fragment>
    );
  }
}

Dialplan.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listIvr: state.ivr.ivrs,
  listPhoneNumber: state.phoneNumber.phoneNumbers,
  count: state.dialplan.count,
  listQueue: state.queue.queue,
  listSound: state.sound.sounds,
  listAction: state.action.action,
  listDialplan: state.dialplan.dialplans,
  listExtension: state.extension.extensions,
});
const Extension = connect(null, ExtensionAction)(Dialplan);
const Sound = connect(null, SoundAction)(Extension);
const Action = connect(null, ActionMap)(Sound);
const Queue = connect(null, QueueAction)(Action);
const Phone = connect(null, PhonenumberAction)(Queue);
const Ivr = connect(null, mapActionsToProps)(Phone);

Dialplan = connect(mapStateToProps, DialplanAction)(Ivr);

export default withStyles(styles)(Dialplan);
